export const TOGGLE_MAP = 'TOGGLE_MAP';
export const SET_DATA = 'SET_DATA';
export const SET_SELECTIONS = 'SET_SELECTIONS';
export const SET_VIEW = 'SET_VIEW';
export const SEARCH_TERMS = 'SEARCH_TERMS';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const SET_PAGE = 'SET_PAGE';
export const SET_PER_PAGE = 'SET_PER_PAGE';
export const SET_FILTERS_LIST = 'SET_FILTERS_LIST';
export const SET_ORDER_BY = 'SET_ORDER_BY';
export const SET_NEW_STATE = 'SET_NEW_STATE';
export const SET_SEARCH_TERMS= 'SET_SEARCH_TERMS';
export const SET_SEARCH_BY_MOVE = 'SET_SEARCH_BY_MOVE'
export const SET_NOT_PAGINATED_DATA_LOADING = 'SET_NOT_PAGINATED_DATA_LOADING'
export const SET_MAP_DATA = 'SET_MAP_DATA'
